import {
	Button,
	Menu,
	MenuItem,
	MenuList,
	MenuPopover,
	MenuTrigger,
} from "@fluentui/react-components";
import { ArrowSort20Regular, Checkmark20Regular } from "@fluentui/react-icons";
import { useIntl } from "react-intl";
import { useSortButtonStyle } from "./style";

export type EmailThreadSortOrder = "oldest-first" | "newest-first";

const OLDEST_FIRST: EmailThreadSortOrder = "oldest-first";
const NEWEST_FIRST: EmailThreadSortOrder = "newest-first";

interface EmailThreadSortButtonProps {
	sortOrder: EmailThreadSortOrder;
	onChange: (sortOrder: EmailThreadSortOrder) => void;
}

export const EmailThreadSortButton = ({
	sortOrder,
	onChange,
}: EmailThreadSortButtonProps) => {
	const classes = useSortButtonStyle();
	const intl = useIntl();

	const newestFirstLabel = intl.formatMessage({ id: "Interaction.EmailEditor.SortNewestFirst" });
	const oldestFirstLabel = intl.formatMessage({ id: "Interaction.EmailEditor.SortOldestFirst" });

	const label = sortOrder === OLDEST_FIRST ? oldestFirstLabel : newestFirstLabel;

	return (
		<Menu>
			<MenuTrigger disableButtonEnhancement>
				<Button
					appearance="transparent"
					icon={<ArrowSort20Regular />}
					className={classes.button}
				>
					{label}
				</Button>
			</MenuTrigger>
			<MenuPopover>
				<MenuList>
					<MenuItem
						icon={sortOrder === NEWEST_FIRST ? <Checkmark20Regular /> : <span className={classes.iconPlaceholder} />}
						onClick={() => onChange(NEWEST_FIRST)}
					>
						{newestFirstLabel}
					</MenuItem>
					<MenuItem
						icon={sortOrder === OLDEST_FIRST ? <Checkmark20Regular /> : <span className={classes.iconPlaceholder} />}
						onClick={() => onChange(OLDEST_FIRST)}
					>
						{oldestFirstLabel}
					</MenuItem>
				</MenuList>
			</MenuPopover>
		</Menu>
	);
};
